<template>
  <div id="needDealt">
    <header-top></header-top>
    <div class="need-dealt">
      <div class="filter">
        <el-button type="primary">批量审批</el-button>
        <div class="line"></div>
        <el-select
          v-model="searchDateType"
          @change="selectsearchDateType"
          placeholder="请选择"
          class="search-type"
          :class="{ custom: searchDateType !== '全部时间' }"
        >
          <el-option
            v-for="item in searchDateTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          class="filter-date"
          v-if="searchDateType !== '全部时间'"
          align="center"
          v-model="dateRange"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>

        <el-select
          v-model="searchSelect"
          @change="filterSelect"
          placeholder="请选择"
          class="search-type search-filter"
        >
          <el-option
            v-for="item in searchTypeOptions"
            :key="item.key"
            :label="item.key"
            :value="item.value"
          ></el-option>
        </el-select>
        <div class="search">
          <el-input
            class="input"
            v-model="searchFilter"
            :placeholder="filterSelectPlaceholder"
            @keyup.enter.native="getCompanies()"
          >
            <i
              class="el-icon-search el-input__icon input__suffix"
              slot="suffix"
              @click="getCompanies()"
            ></i>
          </el-input>
        </div>
      </div>
      <div class="dealt-main">
        <div class="dealt-menu">
          <el-tabs @tab-click="handleClick" v-model="tabsIndex">
            <el-tab-pane label="我发起的" name="我发起的"> </el-tab-pane>
            <el-tab-pane label="待审批" name="待审批"> </el-tab-pane>
            <el-tab-pane label="已审批" name="已审批"> </el-tab-pane>
          </el-tabs>
          <div class="status">
            <el-radio-group v-model="status" v-if="tabsIndex == '我发起的'">
              <el-radio-button label="审批中"></el-radio-button>
              <el-radio-button label="已通过"></el-radio-button>
              <el-radio-button label="已驳回"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="dealt-list">
            <el-table
              ref="dealtList"
              :data="dealtList"
              :show-header="false"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              @select="selectChange"
              @row-click="handleRowClick"
              @select-all="selectAll"
            >
              >
              <el-table-column type="selection" width="30"> </el-table-column>
              <el-table-column label="数据" min-width="120">
                <template slot-scope="scope">
                  <div class="name">
                    {{ scope.row.name }}的{{ scope.row.type }}
                  </div>
                  <div class="detail">
                    <span>发起时间</span>{{ scope.row.startTime }}
                  </div>
                  <div class="detail">
                    <span>结束时间</span>{{ scope.row.endTime }}
                  </div>
                  <div class="detail">
                    <span>审批状态</span>
                    <span
                      class="waiting"
                      v-if="
                        scope.row.status == '待审批' ||
                        scope.row.status == '审批中'
                      "
                      >{{ scope.row.status }}</span
                    >
                    <span class="success" v-if="scope.row.status == '已审批'">{{
                      scope.row.status
                    }}</span>
                    <span class="refuse" v-if="scope.row.status == '已驳回'">{{
                      scope.row.status
                    }}</span>
                    <span class="end" v-if="scope.row.status == '已完结'">{{
                      scope.row.status
                    }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="dealt-details">
          <div class="dealt-title">
            <div class="name">{{ dealtInfo.name }}的{{ dealtInfo.type }}</div>
            <div class="details">
              <div class="detail">
                <span>发起人：</span>{{ dealtInfo.createName }}
              </div>
              <div class="detail">
                <span>发起时间：</span>{{ dealtInfo.createTime }}
              </div>
            </div>
          </div>
          <div class="dealt-info" v-if="dealtInfo.type == '报备通知单'">
            <div class="info-tit">报备信息</div>
            <el-row>
              <el-col :span="12">
                <span>报备项目</span>{{ dealtInfo.estateName }}
              </el-col>
              <el-col :span="12">
                <span>客户姓名</span>{{ dealtInfo.customerName }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>经纪人姓名</span>{{ dealtInfo.brokerName }}
              </el-col>
              <el-col :span="12">
                <span>客户电话</span>{{ dealtInfo.customerPhone }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>经纪人电话</span>{{ dealtInfo.brokerPhone }}
              </el-col>
              <el-col :span="12">
                <span>到访时间</span>{{ dealtInfo.visitTime }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>备注</span>{{ dealtInfo.content }}
              </el-col>
              <el-col :span="12">
                <span>到访人数</span>{{ dealtInfo.visitNum }}
              </el-col>
            </el-row>
          </div>
          <div class="dealt-info" v-if="dealtInfo.type == '带看审核单'">
            <div class="info-tit">带看信息</div>
            <el-row>
              <el-col :span="12">
                <span>报备项目</span>{{ dealtInfo.estateName }}
              </el-col>
              <el-col :span="12">
                <span>客户姓名</span>{{ dealtInfo.customerName }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>经纪人姓名</span>{{ dealtInfo.brokerName }}
              </el-col>
              <el-col :span="12">
                <span>客户电话</span>{{ dealtInfo.customerPhone }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>经纪人电话</span>{{ dealtInfo.brokerPhone }}
              </el-col>
              <el-col :span="12">
                <span>带看时间</span>{{ dealtInfo.visitTime }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="img">
                <span>带看确认单</span>
                <img :src="dealtInfo.url" alt="" v-if="dealtInfo.url" />
                <img src="@/assets/image/default-img.png" alt="" v-else />
              </el-col>
              <el-col :span="12">
                <el-row> <span>陪看人</span>{{ dealtInfo.visitNum }} </el-row>
                <el-row> <span>带看情况</span>{{ dealtInfo.visitNum }} </el-row>
                <el-row> <span>其他附件</span>{{ dealtInfo.visitNum }} </el-row>
              </el-col>
            </el-row>
          </div>
          <div class="dealt-info" v-if="dealtInfo.type == '认领审批单'">
            <div class="info-tit">认领信息</div>
            <el-row>
              <el-col :span="12">
                <span>认领分销商门店名称</span>{{ dealtInfo.estateName }}
              </el-col>
              <el-col :span="12">
                <span>提交时间</span>{{ dealtInfo.createTime }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>认领人</span>{{ dealtInfo.brokerName }}
              </el-col>
              <el-col :span="12">
                <span>备注</span>{{ dealtInfo.content }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>认领人电话</span>{{ dealtInfo.brokerPhone }}
              </el-col>
              <el-col :span="12" class="img">
                <span>附件</span>
                <img :src="dealtInfo.url" alt="" v-if="dealtInfo.url" />
                <img src="@/assets/image/default-img.png" alt="" v-else />
              </el-col>
            </el-row>
          </div>
          <div class="dealt-info" v-if="dealtInfo.type == '业绩审批单'">
            <div class="info-tit">交易信息</div>
            <el-row>
              <el-col :span="12">
                <span>交易编号</span>{{ dealtInfo.estateName }}
              </el-col>
              <el-col :span="12">
                <span>报备单号</span>{{ dealtInfo.customerName }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>新房物业</span>{{ dealtInfo.estateName }}
              </el-col>
              <el-col :span="12">
                <span>房屋信息</span>{{ dealtInfo.customerName }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>客户姓名</span>{{ dealtInfo.brokerName }}
              </el-col>
              <el-col :span="12">
                <span>客户电话</span>{{ dealtInfo.customerPhone }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <span>交易归属</span>{{ dealtInfo.brokerName }}
              </el-col>
            </el-row>
          </div>
          <div class="dealt-info" v-if="dealtInfo.type == '业绩审批单'">
            <div class="info-tit">业绩信息</div>
            <el-row>
              <el-col :span="12"> <span>可分成业绩</span> 10000 .00元 </el-col>
              <el-col :span="12"> <span>客户佣金</span>10000 .00元 </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"> <span>成交价格</span>1500000 .00元 </el-col>
              <el-col :span="12"> <span>应收业绩</span>10000 .00元 </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"> <span>开发商佣金</span>10000 .00元 </el-col>
              <el-col :span="12"> <span>返佣支出</span>10000 .00元 </el-col>
            </el-row>
          </div>

          <div class="dealt-process">
            <div class="info-tit">审批生效</div>
            <div class="process-list">
              <div class="process-info">
                <div class="icon"></div>
                <div class="name">区总李太白审批</div>
                <div class="status">
                  <span>审批状态：</span>
                  <span class="waiting">审批中</span>
                </div>
                <div class="content">
                  <span>审批意见：</span
                  ><el-input
                    type="textarea"
                    placeholder="请输入内容"
                    resize="none"
                  ></el-input>
                </div>
                <div class="btn-box">
                  <span></span>
                  <el-button>驳回</el-button>
                  <el-button type="primary">通过</el-button>
                  <el-button type="primary">审批换人</el-button>
                </div>
              </div>
              <div
                class="process-info"
                v-for="(item, index) in process"
                :key="index"
              >
                <div class="icon"></div>
                <div class="name">{{ item.name }}</div>
                <div class="status">
                  <span>审批状态：</span>
                  <span
                    class="waiting"
                    v-if="item.status == '待审批' || item.status == '审批中'"
                    >{{ item.status }}</span
                  >
                  <span class="refuse" v-if="item.status == '已驳回'">{{
                    item.status
                  }}</span>
                  <span class="success" v-if="item.status == '已通过'">{{
                    item.status
                  }}</span>
                </div>
                <div class="content">
                  <span>审批意见：</span>{{ item.content }}
                </div>
                <div class="time"><span>审批时间：</span>{{ item.time }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";

export default {
  components: {
    headerTop,
  },
  data() {
    return {
      searchDateType: "全部时间",
      status: "审批中",
      dateRange: [],
      dealtInfo: {},
      dealtList: [
        {
          name: "宏业理想城店A叶恒",
          startTime: "2020-10-04 11:30:00",
          endTime: "2020-10-04 11:30:00",
          url: "",
          status: "待审批",
          type: "业绩审批单",
          createName: "张三",
          createTime: "2020-10-02 11:30:00",
          org: "宏业理想城店",
          estateName: "正红澜廷叙",
          brokerName: "李四",
          brokerPhone: "15515515555",
          customerName: "王五",
          customerPhone: "144144144444",
          content: "这个单子比较稳",
          visitNum: 2,
          visitTime: "2020-10-02 11:30:00",
        },
        {
          name: "宏业理想城店",
          startTime: "2020-10-04 11:30:00",
          endTime: "2020-10-04 11:30:00",
          url: "",
          status: "已审批",
          type: "报备通知单",
          createName: "张三",
          createTime: "2020-10-02 11:30:00",
          org: "宏业理想城店",
          estateName: "正红澜廷叙",
          brokerName: "李四",
          brokerPhone: "15515515555",
          customerName: "王五",
          customerPhone: "144144144444",
          content: "这个单子比较稳",
          visitNum: 2,
          visitTime: "2020-10-02 11:30:00",
        },
        {
          name: "宏业理想城店",
          startTime: "2020-10-04 11:30:00",
          endTime: "2020-10-04 11:30:00",
          url: "",
          status: "审批中",
          type: "带看审核单",

          createName: "张三",
          createTime: "2020-10-02 11:30:00",
          org: "宏业理想城店",
          estateName: "正红澜廷叙",
          brokerName: "李四",
          brokerPhone: "15515515555",
          customerName: "王五",
          customerPhone: "144144144444",
          content: "这个单子比较稳",
          visitNum: 2,
        },
        {
          name: "宏业理想城店",
          startTime: "2020-10-04 11:30:00",
          endTime: "2020-10-04 11:30:00",
          url: "",
          status: "已驳回",
          type: "认领审批单",
          createName: "张三",
          createTime: "2020-10-02 11:30:00",
          org: "宏业理想城店",
          estateName: "正红澜廷叙",
          brokerName: "李四",
          brokerPhone: "15515515555",
          customerName: "王五",
          customerPhone: "144144144444",
          content: "这个单子比较稳",
          visitNum: 2,
          visitTime: "2020-10-02 11:30:00",
        },
        {
          name: "宏业理想城店",
          startTime: "2020-10-04 11:30:00",
          endTime: "2020-10-04 11:30:00",
          url: "",
          status: "已完结",
          type: "认领审批单",
          createName: "张三",
          createTime: "2020-10-02 11:30:00",
          org: "宏业理想城店",
          estateName: "正红澜廷叙",
          brokerName: "李四",
          brokerPhone: "15515515555",
          customerName: "王五",
          customerPhone: "144144144444",
          content: "这个单子比较稳",
          visitNum: 2,
          visitTime: "2020-10-02 11:30:00",
        },
        {
          name: "宏业理想城店A叶恒",
          startTime: "2020-10-04 11:30:00",
          endTime: "2020-10-04 11:30:00",
          url: "",
          status: "待审批",
          type: "业绩审批单",
          createName: "张三",
          createTime: "2020-10-02 11:30:00",
          org: "宏业理想城店",
          estateName: "正红澜廷叙",
          brokerName: "李四",
          brokerPhone: "15515515555",
          customerName: "王五",
          customerPhone: "144144144444",
          content: "这个单子比较稳",
          visitNum: 2,
          visitTime: "2020-10-02 11:30:00",
        },
      ],
      process: [
        {
          name: "宏业理想城店A叶恒的业绩单",
          status: "已通过",
          content: "没啥意见，挺好",
          time: "2020-10-04 11:30:00",
        },
        {
          name: "宏业理想城店A叶恒的业绩单",
          status: "已通过",
          content: "没啥意见，挺好",
          time: "2020-10-04 11:30:00",
        },
        {
          name: "宏业理想城店A叶恒的业绩单",
          status: "待审批",
          content: "没啥意见，挺好",
          time: "2020-10-04 11:30:00",
        },
      ],
      tabsIndex: "我发起的",
      searchDateTypeOptions: [
        {
          key: "全部时间",
          value: "全部时间",
        },
        {
          key: "开始时间",
          value: "开始时间",
        },
        {
          key: "结束时间",
          value: "结束时间",
        },
      ],
      searchSelect: "前缀搜索",
      //搜索类型选择数据
      searchTypeOptions: [
        {
          key: "前缀搜索",
          value: "请输入分销商名称前缀",
        },
        {
          key: "联系方式",
          value: "请输入联系电话",
        },
        {
          key: "电子邮箱",
          value: "请输入电子邮箱",
        },
        {
          key: "全文搜索",
          value: "名称/电话/邮箱",
        },
      ],
      searchFilter: "", //搜索内容
      filterSelectPlaceholder: "请输入名称前缀",
      handleSelectionList: [],
    };
  },
  mounted() {
    this.dealtInfo = this.dealtList[0];
  },
  methods: {
    handleSelectionChange(value) {
      this.handleSelectionList = value;
      this.dealtInfo = value[0];
      //console.log(this.dealtInfo, 9875);
    },

    selectChange(selection, row) {
      if (selection.length > 1) {
        const del_row = selection.shift();
        this.$refs.dealtList.toggleRowSelection(del_row, false);
      }
    },
    // 点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.$refs.dealtList.toggleRowSelection(row);
      this.selectChange(this.handleSelectionList);
    },
    selectAll(selection) {
      if (selection.length > 1) {
        selection.length = 1;
      }
    },
    filterSelect(val) {
      this.filterSelectPlaceholder = val;
      if (val == "请输入名称前缀") {
        this.query.condition = "Name";
      } else if (val == "请输入联系电话") {
        this.query.condition = "PhoneNumber";
      } else if (val == "请输入电子邮箱") {
        this.query.condition = "Email";
      } else if (val == "名称/电话/邮箱") {
        this.query.condition = "";
      }
    },
    getCompanies() {},
    handleClick() {},
    selectsearchDateType(val) {},
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#needDealt {
  .need-dealt {
    margin: 20px;
    .filter {
      @include flex(row, center);
      .line {
        margin: 0 10px;
        border-left: 1px solid #dfdfdf;
        width: 0px;
        height: 20px;
      }
      .search-type {
        width: 150px;
      }
      .custom {
        ::v-deep .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
      .el-date-editor {
        height: 30px;
        border-left-color: transparent;
      }
      .filter-date {
        border-radius: 0px 4px 4px 0;
        border-left-color: transparent;
        &:hover {
          border-color: #ddd;
          border-left: 0px solid transparent;
        }
        &.isactive {
          border-color: $--color-primary;
        }
      }
      .search-filter {
        margin-left: 70px;
        width: 100px;
        ::v-deep .el-input__inner {
          border-right: 0;
          border-radius: 4px 0 0 4px;
        }
      }
      .search {
        ::v-deep .el-input__inner {
          border-radius: 0 4px 4px 0;
        }
      }
    }

    .dealt-main {
      @include flex(row, stretch);
      padding: 20px 0;
      .dealt-menu {
        box-sizing: border-box;
        margin-right: 20px;
        padding: 10px 0;
        width: 330px;
        min-height: calc(100vh - 140px);
        background: #fff;
        ::v-deep .el-tabs {
          border-bottom: 1px solid #e0e0e0;
          .el-tabs__header {
            box-shadow: 0 0 0px rgba(0, 0, 0, 0);
          }
          .el-tabs__nav-scroll {
            padding-left: 10px;
          }
        }
        .status {
          width: 100%;
          text-align: center;
          ::v-deep .el-radio-group {
            margin-top: 20px;
            .isactive {
              .el-radio-button__inner {
                background-color: #fff;
                color: $--color-primary;
              }
            }
          }
        }
        .dealt-list {
          ::v-deep .el-table {
            td {
              vertical-align: top;
              padding: 26px 0;
              .cell {
                .name {
                  font-size: 16px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #666666;
                }
                .detail {
                  margin-top: 20px;
                  color: #666;
                  span {
                    padding-right: 20px;
                    color: #666;
                  }
                  .waiting {
                    color: #387cef;
                  }
                  .success {
                    color: #6dc035;
                  }
                  .refuse {
                    color: #fd3c3d;
                  }
                  .end {
                    color: #878686;
                  }
                }
              }
            }
          }
        }
      }
      .dealt-details {
        width: 100%;
        min-height: calc(100vh - 135px);
        background: #fff;
        .dealt-title {
          padding: 40px 40px 30px;
          border-bottom: 1px solid #e0e0e0;
          .name {
            margin-bottom: 30px;
            width: 100%;
            text-align: center;
            font-size: 16px;
            color: #717171;
          }
          .details {
            @include flex(row, center);
            .detail {
              margin-right: 50px;
              color: #666;
              span {
                display: inline-block;
                width: 70px;
                color: #666;
              }
            }
          }
        }
        .dealt-info {
          padding: 40px;
          border-bottom: 1px solid #e0e0e0;
          .info-tit {
            font-size: 16px;
            color: #666;
            margin-bottom: 26px;
          }
          .el-row {
            margin-bottom: 25px;

            .el-col {
              color: #000;
              img {
                width: 124px;
                height: auto;
                max-height: 200px;
              }
              span {
                display: inline-block;
                width: 100px;
                color: #666;
              }
            }
            .img {
              @include flex(row, flex-start);
            }
          }
        }
        .dealt-process {
          .info-tit {
            padding: 30px 40px 0;
            font-size: 16px;
            color: #666;
          }
          .process-list {
            padding: 26px 40px 0;
            .process-info {
              position: relative;
              padding: 0px 32px 17px;
              border-left: 1px solid #e0e0e0;
              .icon {
                position: absolute;
                top: 0px;
                left: -9px;
                border-radius: 50%;
                border: 5px solid #f3f6fc;
                width: 7px;
                height: 7px;
                background: $--color-primary;
              }
              .name {
                padding-bottom: 20px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #666666;
              }
              .status,
              .content,
              .time,
              .btn-box {
                @include flex(row,flex-start);
                padding-bottom: 20px;
                color: #666666;
                span {
                  display: inline-block;
                  width: 100px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                }
                .waiting {
                  color: #387cef;
                }
                .success {
                  color: #6dc035;
                }
                .refuse {
                  color: #fd3c3d;
                }
                .el-textarea{
                  width: 430px;
                }
              }
            }
            .process-info:last-child {
              border-left: 1px solid #fff;
            }
          }
        }
      }
    }
  }
}
</style>
